import { useState, useEffect } from "react";
import { observeAuth } from "@/firebase/auth.custom";
import { db } from "@/firebase/firebase-config";
import { doc, onSnapshot } from "firebase/firestore";
import type { User } from "firebase/auth";

export function usePlan() {
  const [loading, setLoading] = useState(true);
  const [plan, setPlan] = useState<string | null>(null);
  const [isGuest, setIsGuest] = useState(true);

  useEffect(() => {
    const unsubAuth = observeAuth((user: User | null) => {
      if (!user) {
        setPlan(null);
        setIsGuest(true);
        setLoading(false);
        return;
      }

      const userRef = doc(db(), "users", user.uid);
      const unsubDoc = onSnapshot(userRef, (snap) => {
        if (snap.exists()) {
          const data = snap.data();
          setPlan(data?.subscriptionTier || "free");
          setIsGuest(data?.subscriptionTier === "free" || !data?.subscriptionTier);
        } else {
          setPlan("free");
          setIsGuest(true);
        }
        setLoading(false);
      });

      return () => unsubDoc();
    });

    return () => unsubAuth();
  }, []);

  return { loading, plan, isGuest };
}
